export * from './InfoModal';
